export function resolveAssignmentMethodLabel(method?: string | null): string | null {
  if (!method) return null
  if (method === 'auto') return 'Auto-assigned'
  if (method === 'manual') return 'Manual'
  return method
}

export function assignmentMethodBadgeColor(method?: string | null): string {
  if (method === 'auto') return 'purple'
  if (method === 'manual') return 'gray'
  return 'gray'
}
